import React from 'react'
import { connect } from 'react-redux'
import Grid from '@material-ui/core/Grid'
import { aggregateBy } from '@progress/kendo-data-query'
import DataPanel from 'components/theme/DataPanel'
import language from 'utils/vast-languagepack'
import formatStatNumber from 'utils/formatStatNumber'

export default connect(
  state => ({ tasksByID: state.tasks.tasksByID }),
  null,
)(({ tasksByID, half, ownedBy }) => {
  const emailTaskStats = Object.values(tasksByID)
    .filter(task => {
      if (ownedBy) {
        return (
          task.owned_by &&
          task.owned_by.id === ownedBy.id &&
          task.owned_by.type === ownedBy.type &&
          task.task_type_id === '1'
        )
      }
      return task.task_type_id === '1'
    })
    .map(x => {
      return x.email_stats
        ? {
            unique_opens: x.email_stats.unique_opens
              ? x.email_stats.unique_opens
              : 0,
            unique_clicks: x.email_stats.unique_clicks
              ? x.email_stats.unique_clicks
              : 0,
            total_sends: x.email_stats.total_sends
              ? x.email_stats.total_sends
              : 0,
          }
        : { unique_opens: 0, unique_clicks: 0, total_sends: 0 }
    })

  const emailAggregates = aggregateBy(emailTaskStats, [
    { field: 'unique_opens', aggregate: 'sum' },
    { field: 'total_sends', aggregate: 'sum' },
    { field: 'unique_clicks', aggregate: 'sum' },
  ])

  const smsTaskStats = Object.values(tasksByID)
    .filter(task => {
      if (ownedBy) {
        return (
          task.owned_by &&
          task.owned_by.id === ownedBy.id &&
          task.owned_by.type === ownedBy.type &&
          task.task_type_id === '2'
        )
      }
      return task.task_type_id === '2'
    })
    .map(x => {
      return x.sms_stats
        ? {
            total_delivered: x.sms_stats.total_delivered
              ? x.sms_stats.total_delivered
              : 0,
            total_sends: x.sms_stats.total_sends ? x.sms_stats.total_sends : 0,
          }
        : { total_delivered: 0, total_sends: 0 }
    })

  const smsAggregates = aggregateBy(smsTaskStats, [
    { field: 'total_delivered', aggregate: 'sum' },
    { field: 'total_sends', aggregate: 'sum' },
  ])

  return (
    <Grid justify="center" container spacing={16}>
      <Grid item xs>
        <DataPanel
          half={half}
          value={
            emailAggregates.unique_opens && emailAggregates.total_sends
              ? Math.round(
                  (emailAggregates.unique_opens.sum /
                    emailAggregates.total_sends.sum) *
                    100,
                )
              : 0
          }
          property="Opened"
          arcGauge
          color="green"
          label={`${
            emailAggregates.unique_opens
              ? formatStatNumber(emailAggregates.unique_opens.sum)
              : '--'
          } ${language.task.viewAll.stats.emailOpens}${
            emailAggregates.unique_opens &&
            emailAggregates.unique_opens.sum === 1
              ? ''
              : 's'
          }`}
        />
      </Grid>
      <Grid item xs>
        <DataPanel
          half={half}
          arcGauge
          property="Clicked"
          value={
            emailAggregates.unique_clicks && emailAggregates.total_sends
              ? Math.round(
                  (emailAggregates.unique_clicks.sum /
                    emailAggregates.total_sends.sum) *
                    100,
                )
              : 0
          }
          color="orange"
          label={`${
            emailAggregates.unique_clicks
              ? formatStatNumber(emailAggregates.unique_clicks.sum)
              : '--'
          } ${language.task.viewAll.stats.uniqueClicks}${
            emailAggregates.unique_clicks &&
            emailAggregates.unique_clicks.sum === 1
              ? ''
              : 's'
          }`}
        />
      </Grid>
      <Grid item xs>
        <DataPanel
          half={half}
          arcGauge
          property="Delivered"
          value={
            smsAggregates.total_delivered && smsAggregates.total_sends
              ? Math.round(
                  (smsAggregates.total_delivered.sum /
                    smsAggregates.total_sends.sum) *
                    100,
                )
              : 0
          }
          color="pink"
          label={`${
            smsAggregates.total_delivered
              ? formatStatNumber(smsAggregates.total_delivered.sum)
              : '--'
          } ${language.task.viewAll.stats.smsDelivered}`}
        />
      </Grid>
      <Grid item xs>
        <DataPanel
          half={half}
          value={
            emailAggregates.total_sends ? emailAggregates.total_sends.sum : '--'
          }
          color="blue"
          label={`${language.task.viewAll.stats.totalSends}${
            emailAggregates.total_sends && emailAggregates.total_sends.sum === 1
              ? ''
              : 's'
          }`}
        />
      </Grid>
      <Grid item xs>
        <DataPanel
          half={half}
          value={
            smsAggregates.total_sends ? smsAggregates.total_sends.sum : '--'
          }
          color="purple"
          label={`${language.task.viewAll.stats.smsSends}${
            smsAggregates.total_sends && smsAggregates.total_sends.sum === 1
              ? ''
              : 's'
          }`}
        />
      </Grid>
    </Grid>
  )
})
